module.exports = __webpack_public_path__ + "static/media/alpide-logo.09b167ed.png";